import React from 'react';
import { FiUsers } from 'react-icons/fi';
import Sidebar from '../Sidebar/Sidebar';
import styles from './Invite.module.css';
import * as utils from '../../utils/utils';

const MAX_EMAILS = 5;

export default class Invite extends React.Component {
    constructor(props) {
        super(props);

        // State initialization
        this.state = {
            emails: [''],
            isSending: false,
            successText: '',
            errorText: '',
        };
    };

    onEmailChange = (index, value) => {
        this.setState({
            successText: '',
            errorText: '',
        });

        this.setState((prevState) => {
            const nextEmails = [...prevState.emails];
            nextEmails[index] = value;

            const isLastInput = index === nextEmails.length - 1;
            const canAddMore = nextEmails.length < MAX_EMAILS;

            // Automatically dynamically append a new empty field if typing in the last input
            if (isLastInput && value.trim() !== '' && canAddMore) {
                nextEmails.push('');
            }

            return { emails: nextEmails };
        });
    };

    onInviteFriends = async () => {
        if (this.state.isSending) {
            return;
        }

        const cleanedEmails = Array.from(
            new Set(
                this.state.emails
                    .map((email) => String(email || '').trim().toLowerCase())
                    .filter((email) => email !== '')
            )
        );

        if (cleanedEmails.length === 0) {
            this.setState({ errorText: 'Please enter at least one email.' });
            return;
        }

        this.setState({
            isSending: true,
            errorText: '',
            successText: '',
        });

        try {
			await utils.sendRequest('/invite/invite', {
				emails: cleanedEmails,
			});

            this.setState({
                emails: [''],
                successText: 'Invites sent!',
            });
        } catch (error) {
            this.setState({
                errorText: error?.message || 'Could not send invites right now.',
            });
        } finally {
            this.setState({
                isSending: false,
            });
        }
    };

    render() {
        const { emails, isSending, successText, errorText } = this.state;

        return (
            <div className={styles.pageContainer}>
                <Sidebar />

                <div className={styles.glowLayer}>
                    <div className={styles.glowTop} />
                    <div className={styles.glowBottom} />
                </div>

                <div className={styles.layoutShell}>
                    <section className={styles.cardPanel}>
                        <div className={styles.sectionHeader}>
                            <h2 className={styles.formTitle}>
                                <FiUsers /> Invite Friends to Join HQ
                            </h2>
                            <p className={styles.formText}>
                                Build a professional network of like-minded individuals. Invite your friends to join HQ and grow together.
                            </p>
                        </div>

                        <div className={styles.contentSection}>
                            {emails.map((email, index) => (
                                <div key={`invite-email-${index}`} className={styles.inputWrapper}>
                                    <label className={styles.inputLabel} htmlFor={`invite-email-${index}`}>
                                        Email {index + 1}
                                    </label>
                                    <input
                                        id={`invite-email-${index}`}
                                        type="text"
                                        value={email}
                                        onChange={(event) => this.onEmailChange(index, event.target.value)}
                                        className={styles.input}
                                        placeholder="friend@example.com"
                                        autoComplete="off"
                                    />
                                </div>
                            ))}

                            {errorText !== '' && <div className={styles.errorBox}>{errorText}</div>}
                            {successText !== '' && <div className={styles.successBox}>{successText}</div>}

                            <button
                                type="button"
                                className={styles.primaryButton}
                                onClick={this.onInviteFriends}
                                disabled={isSending}
                            >
                                {isSending ? 'Sending...' : 'Invite Friends'}
                            </button>
                        </div>
                    </section>
                </div>
            </div>
        );
    };
}